import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { UsersService } from "../services/users.service";

/**
 * Structural directive that conditionally displays an element based on whether the current user's email
 * is included in a provided list of allowed emails.
 *
 * @example
 * <button *isUser="['admin@example.com', 'dev@example.com']">Admin action</button>
 *
 * @selector [isUser]
 * @input emails - Array of allowed user emails.
 */
@Directive({
  selector: "[isUser]",
})
export class IsUserDirective {
  private emails: string[] = [];

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private usersService: UsersService
  ) {}

  @Input()
  set isUser(emails: string[]) {
    this.emails = emails || [];
    this.updateView();
  }

  private updateView() {
    const user = this.usersService.getCurrentUser();
    const validUser = this.emails.includes(user.email);

    this.viewContainer.clear();
    if (validUser) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
